const data = [
  {
    catalog: 'ORIGINALS',
    actions: '',
  },
];

export { data };
